// generated by the plop

import { PaginatorModel, PROGRESS_STATUSES } from 'symbols';
import { ContractModel } from '../../symbols';

export interface ContractListStateModel {
  contractList: PaginatorModel<ContractModel>;
  loadContractListStatus: PROGRESS_STATUSES;
  lastOpenedDocId: string;
  scrollPosition: number;
}

export const CONTRACT_LIST_STATE_DEFAULT: ContractListStateModel = {
  contractList: {
    data: [],
    meta: null,
    links: null
  },
  loadContractListStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastOpenedDocId: null,
  scrollPosition: 0
};
